import React from 'react';

import { Trans } from 'lingui-react';
import { Modal, ModalBody, Button } from 'reactstrap'

import shapeConfirm from '../../../../../../assets/images/shapeConfirm.svg'


export const ModalConfirm = (props) => {
  return (
    <Modal backdrop='static' isOpen={props.modal} toggle={props.toggle} className={'mx-auto modal-confirm-exit ' + props.className} >
      <ModalBody>
        <div className="row">
          <div className="col-12 col-sm-2 d-flex flex-row justify-content-sm-center">
            <img className="img-fluid mx-auto" alt="" src={shapeConfirm} />
          </div>
          <div className="col-12 col-sm-10">
            <p className="modal-title"><Trans id="Would you like to leave the questionnaire?" /></p>
            <p className="modal-text"><Trans id="Your answers have been saved. You can continue with the questions later." /></p>
            <div className="col-sm-7 col-12 offset-sm-5 no-padding d-flex flex-row justify-content-between">
              <Button className="yes-button command-button" color="primary" onClick={props.accept}><Trans id="Yes" /></Button>
              <Button className="no-button command-button" color="primary" onClick={props.toggle}><Trans id="No" /></Button>
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
}


// WEBPACK FOOTER //
// ./src/components/Header/components/HeaderQuestion/components/ModalConfirm/ModalConfirm.js